const exportUserContent = () => {
  let highlights = [];
  let notes = [];
  for (let highlight of window.v7.userContent.highlights) {
    let refactoredHighlight = {
      cfi: highlight.cfi,
      snippet: highlight.snippet,
      color: highlight.color,
      documentIndex: highlight.document?.index,
      pageIndex: highlight.page?.index,
      markerIndex: highlight.marker?.index,
    };
    highlights.push(refactoredHighlight);
  }
  for (let note of window.v7.userContent.notes) {
    let refactoredNote = {
      cfi: note.cfi,
      snippet: note.snippet,
      color: note.color,
      documentIndex: note.document?.index,
      pageIndex: note.page?.index,
      markerIndex: note.marker?.index,
      userText: note.userText,
    };
    notes.push(refactoredNote);
  }
  return {
    url: window.location.href, // 'include current url for debugging purposes
    timestamp: new Date().toISOString(), // include current timestamp for debugging purposes
    user: {
      // include basic user info for debugging purposes
      id: window.v7.session.user.pk,
      name: window.v7.session.user.name,
    },
    bookInfo: {
      id: window.v7.book.pk,
      title: window.v7.book.title,
    },
    highlights: highlights,
    notes: notes,
    // TODO  include copied content, flashcards, etc, later.
  };
};

export default exportUserContent;
